import { Color, Engine, FadeInOut } from "excalibur";
import { BaseFlow } from "../engine/baseFlow";
import { loader } from "../resources";
import { MainGameFlow } from "./mainGameFlow";
import { MyLevel } from "../level";
import { DataManager } from "../dataManager";
import { initializeConstants } from "../constants";

export type StartGameResult = Record<string, never>;

export class StartGameFlow extends BaseFlow<StartGameResult> {
  constructor(public game: Engine) {
    super(game.clock);
  }

  override async Execute() {
    // Load game data before starting
    const dataManager = DataManager.getInstance();
    await dataManager.loadGameData();
    
    // Initialize constants with loaded data
    initializeConstants();
    
    await this.game.start("start", {
      // name of the start scene 'start'
      loader, // Optional loader (but needed for loading images/sounds)
      inTransition: new FadeInOut({
        // Optional in transition
        duration: 1000,
        direction: "in",
        color: Color.ExcaliburBlue,
      }),
    });

    MainGameFlow.runAndWait(
      new MainGameFlow(this.game.currentScene as MyLevel),
    );
  }
}
